import {
  Description,
  Dictionary,
  Expression,
  GridData,
  GridDataOptions,
} from "./schema";
import instance from "../../util/axios";
import dayjs from "dayjs";

export function getDictionaryMapper(descriptions: Description[]) {
  const mapper: { [key: string]: string } = {};
  descriptions
    .filter((item: Description) => item.dictionary)
    .forEach((desc: Description) => {
      mapper[desc.fieldName!] = desc.dictionary!;
    });
  return mapper;
}

function formatExpressions(expressions?: Expression[]) {
  const expression = new Expression("数量", "count(1)");
  expression.format = function (value) {
    return `共${value}项`;
  };
  if (expressions) {
    if (!expressions.some((item) => item.field === "数量")) {
      expressions.push(expression);
    }
  } else {
    expressions = [expression];
  }
  return expressions;
}

export async function getGridData(options: GridDataOptions): Promise<GridData> {
  const formattedPager = options.pagination
    ? options.pager || { pageIndex: 1, pageSize: 10 }
    : {
        pageIndex: 0,
        pageSize: 0,
      };
  let dictionaryNames = "";
  for (const prop in options.dictionaryMapper) {
    // eslint-disable-next-line no-prototype-builtins
    if (options.dictionaryMapper.hasOwnProperty(prop)) {
      if (dictionaryNames.length > 0) {
        dictionaryNames += ",";
      }
      const dictionaryName = options.dictionaryMapper[prop];
      dictionaryNames += prop + "." + dictionaryName;
    }
  }

  const data: any = {
    pageIndex: formattedPager.pageIndex,
    pageSize: formattedPager.pageSize,
    dictionaryNames,
    ...options.searchForm,
    expressions: JSON.stringify(formatExpressions(options.expressions)),
  };
  if (options.sorter?.field) {
    if (options.sorter?.order) {
      data.sort = options.sorter.order === "descend" ? "desc" : "asc";
    } else {
      data.sort = "";
    }
    data.sortField = options.sorter.field;
  }
  if (options.fuzzySearch) {
    data.fuzzySearch = options.fuzzySearch;
    options.innerDescriptions?.forEach((item) => {
      const type =
        item.inputType === 6 || item.inputType === 8
          ? "dictionary"
          : item.inputType === 4
          ? "datetime"
          : item.inputType === 2
          ? "number"
          : item.inputType === 3
          ? "bool"
          : "string";
      if (item.fieldName) {
        data["searchField_" + type + "_" + item.fieldName] = "";
      }
    });
    for (const key in data) {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        if (key.indexOf("searchField") > -1) {
          data[key] = "";
        }
      }
    }
  }
  const response = await instance.post(options.url, data);
  return response.data.Data;
}

export function getPagination(
  { pageIndex, pageSize }: GridData,
  total: number
) {
  return {
    current: pageIndex,
    pageSize: pageSize,
    total: total,
  };
}

export function getDataSource(
  { data, dictionary }: GridData,
  descriptions: Description[]
) {
  return data.map((data: { [key: string]: any }) => {
    const result = Object.assign({}, data);
    result.key = data.uuid;
    result.ref = data;
    result.ref.dictionary = dictionary;
    descriptions.length > 0 &&
      descriptions.forEach((description: Description) => {
        // todo: should not change original values
        if (description.inputType === 3) {
          result[description.fieldName!] = result[description.fieldName!]
            ? "是"
            : "否";
        }
        if (
          description.inputType === 4 &&
          description.format &&
          result[description.fieldName!]
        ) {
          const dateFormat = description.format
            ? description.format
                .toUpperCase()
                .replace(/:MM/g, ":mm")
                .replace(/SS/g, "ss")
            : "YYYY-MM-DD HH:mm:ss";
          result[description.fieldName!] = dayjs(
            result[description.fieldName!]
          ).format(dateFormat);
          data[description.fieldName!] = dayjs(
            data[description.fieldName!]
          ).format(dateFormat);
        }
      });
    for (const prop in dictionary) {
      // eslint-disable-next-line no-prototype-builtins
      if (dictionary.hasOwnProperty(prop)) {
        const fieldName = prop.split(".")[0];
        const items = dictionary[prop];
        result[fieldName] = items
          .filter((item: Dictionary) => {
            return (
              result[fieldName] &&
              (Array.isArray(result[fieldName])
                ? result[fieldName].includes(item.value)
                : result[fieldName].split(",").includes(item.value))
            );
          })
          .map((item: Dictionary) => item.text)
          .join(",");
      }
    }
    return result;
  });
}
